import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
`;
Wrapper.displayName = 'Wrapper';
